import Box, { BoxProps } from "../box/Box";
import React, { forwardRef, FunctionComponent } from "react";

export interface FlexRowCenterProps extends Omit<BoxProps, "alignItems" | "display" | "flexDirection"> {
	inline?: boolean;
}

export const FlexRowCenter: FunctionComponent<FlexRowCenterProps> = forwardRef((props, ref) => {
	const { children, inline, ...otherProps } = props;

	return (
		<Box
			alignItems="center"
			display={inline ? "inline-flex" : "flex"}
			{...{ ref }}
			{...otherProps}
		>
			{children}
		</Box>
	);
});

export default FlexRowCenter;